import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg2Fa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 240,
	height: 145,
	viewBox: "0 0 240 145",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 22.6367,
			y: 38.2324,
			width: 167.649,
			height: 105.011,
			fill: "white",
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 21.6367,
			y1: 58.7056,
			x2: 191.286,
			y2: 58.7056,
			stroke: "#3C59F6",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M169.52 73.8451C169.519 73.8447 169.519 73.8431 169.52 73.8427L202.569 59.7419C203.815 59.2105 205.223 59.207 206.471 59.7323L239.999 73.8431C240 73.8434 240 73.8444 239.999 73.8447C239.999 73.8448 239.998 73.8451 239.998 73.8455C239.998 98.7338 234.998 122.677 204.76 137.236C204.76 137.236 204.76 137.236 204.76 137.236C204.76 137.236 204.76 137.236 204.76 137.236L204.76 137.236C204.76 137.236 204.76 137.236 204.76 137.236L204.76 137.236C204.76 137.236 204.759 137.236 204.759 137.236C204.759 137.236 204.759 137.236 204.759 137.236C174.522 122.677 169.521 98.7343 169.521 73.8464C169.521 73.8458 169.521 73.8453 169.52 73.8451Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 204.726,
			cy: 88.5697,
			r: 8.44279,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.651 101.747C213.675 98.2773 204.762 98.0732 204.762 98.0732C204.762 98.0732 195.849 98.2773 193.873 101.747C193.079 103.14 192.629 110.734 192.629 113.378H216.886C216.886 110.734 216.445 103.14 215.651 101.747Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.6165 96.3981L76.9185 94.0141L71.9624 95.6034L71.9973 90.2935H69.5542L69.5891 95.6034L64.5982 94.0141L63.8652 96.3981L68.8213 97.9514L65.6801 102.25L67.5997 103.731L70.7409 99.3602L73.9169 103.731L75.8714 102.25L72.6954 97.9514L77.6165 96.3981Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M101.43 96.3981L100.732 94.0141L95.776 95.6034L95.8109 90.2935H93.3678L93.4027 95.6034L88.4118 94.0141L87.6788 96.3981L92.6349 97.9514L89.4937 102.25L91.4133 103.731L94.5545 99.3602L97.7305 103.731L99.685 102.25L96.509 97.9514L101.43 96.3981Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.244 96.3981L124.546 94.0141L119.59 95.6034L119.625 90.2935H117.181L117.216 95.6034L112.225 94.0141L111.492 96.3981L116.448 97.9514L113.307 102.25L115.227 103.731L118.368 99.3602L121.544 103.731L123.499 102.25L120.323 97.9514L125.244 96.3981Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.057 96.3981L148.359 94.0141L143.403 95.6034L143.438 90.2935H140.995L141.03 95.6034L136.039 94.0141L135.306 96.3981L140.262 97.9514L137.121 102.25L139.041 103.731L142.182 99.3602L145.358 103.731L147.312 102.25L144.136 97.9514L149.057 96.3981Z",
			fill: "#3C59F6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 4.14852,
			cy: 3.11139,
			rx: 4.14852,
			ry: 3.11139,
			transform: "matrix(-1 0 0 1 8.29688 21.7046)",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 4.14852,
			cy: 3.11139,
			rx: 4.14852,
			ry: 3.11139,
			transform: "matrix(-1 0 0 1 232.686 138.294)",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.511 3.04472C32.8539 1.9064 31.2109 1.9064 30.5537 3.04472L28.3162 6.92055C28.1524 7.20427 27.9105 7.43488 27.6192 7.58486L23.7372 9.58386C22.5029 10.2194 22.5029 11.9841 23.7372 12.6197L27.6192 14.6187C27.9105 14.7687 28.1524 14.9993 28.3162 15.283L30.5537 19.1589C31.2109 20.2972 32.8539 20.2972 33.511 19.1589L35.7486 15.283C35.9123 14.9993 36.1543 14.7687 36.4456 14.6187L40.3276 12.6197C41.5619 11.9841 41.5619 10.2194 40.3276 9.58386L36.4456 7.58486C36.1543 7.43488 35.9123 7.20427 35.7486 6.92055L33.511 3.04472Z",
			fill: "#F385FF"
		})
	]
});
export default Svg2Fa;
